import { hasOAuth1Bootstrap } from './hasOAuth1Bootstrap.js';

const OAUTH1_TOKEN_FIELDS = Object.freeze([
  { key: 'accessToken', name: 'Access Token', placeholder: 'Access token', dataType: 'string', required: true, isSensitive: true },
  { key: 'tokenSecret', name: 'Token Secret', placeholder: 'Token secret', dataType: 'string', required: true, isSensitive: true }
]);

const STANDARD_AUTH_FIELD_MAP = Object.freeze({
  apiKey: [{ key: 'apiKey', name: 'API Key', placeholder: 'API key', dataType: 'string', required: true, isSensitive: true }],
  basic: [
    { key: 'username', name: 'Username', placeholder: 'Username', dataType: 'string', required: true, isSensitive: false },
    { key: 'password', name: 'Password', placeholder: 'Password', dataType: 'string', required: true, isSensitive: true }
  ],
  oAuth1: [
    { key: 'consumerKey', name: 'Consumer Key', placeholder: 'Consumer key', dataType: 'string', required: true, isSensitive: true },
    { key: 'consumerSecret', name: 'Consumer Secret', placeholder: 'Consumer secret', dataType: 'string', required: true, isSensitive: true },
    { key: 'realm', name: 'Realm', placeholder: 'Realm', dataType: 'string', required: false, isSensitive: false }
  ],
  oAuth2: [],
  custom: [],
  none: []
});

const applyArgumentLabelOverride = (field, auth) => {
  const overrideLabel = auth?.argumentOverrides?.[field.key]?.label;
  if (typeof overrideLabel !== 'string' || overrideLabel.length === 0) {
    return field;
  }
  return { ...field, name: overrideLabel, placeholder: overrideLabel };
};

export const getStandardAuthFields = ({ authType, auth } = {}) => {
  const baseFields = STANDARD_AUTH_FIELD_MAP[authType] || [];
  const nextFields = baseFields.map((field) => applyArgumentLabelOverride({ ...field }, auth));

  if (authType === 'oAuth1' && !hasOAuth1Bootstrap(auth)) {
    nextFields.splice(2, 0, ...OAUTH1_TOKEN_FIELDS.map((field) => ({ ...field })));
  }

  return nextFields;
};
